import { render, staticRenderFns } from "./DashProfile.vue?vue&type=template&id=9fdb37fa&scoped=true&"
import script from "./DashProfile.vue?vue&type=script&lang=js&"
export * from "./DashProfile.vue?vue&type=script&lang=js&"
import style0 from "./DashProfile.vue?vue&type=style&index=0&id=9fdb37fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdb37fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VCol,VExpandTransition,VIcon,VRow,VSheet})
